// @ts-check

import { service } from '@/core/constants'
import axios from 'axios'

const getBaseUrl = () => {
  if (process.env.VUE_APP_SERVICE === service.TLP) {
    return 'https://www.ukko.fi/wp-json/ukko/v1/tlp/'
  }

  if (process.env.VUE_APP_SERVICE === service.UKKOPRO) {
    return 'https://www.ukko.fi/wp-json/ukko/v1/tmi/'
  }

  if (process.env.VUE_APP_SERVICE === service.OY) {
    return 'https://www.ukko.fi/wp-json/ukko/v1/oy/'
  }

  throw new Error('Unknown service!')
}

// Ukkoturva URL paths for WordPress API
export const UKKOTURVA_OVERVIEW = 'ukkoturva-overview'
export const UKKOTURVA_INSURANCE = 'ukkoturva-insurance'
export const UKKOTURVA_INSURANCE_CHILD_PAGES = 'ukkoturva-insurance-child-pages'
export const UKKOTURVA_BENEFITS = 'ukkoturva-benefits'
export const UKKOTURVA_COURSES = 'ukkoturva-courses-and-guides'
export const UKKOTURVA_CONTRACT_LIBRARY = 'ukkoturva-contract-library'

export const initAssuranceState = () => {
  return {
    ukkoturvaData: null // cache object containing all the data received from WordPress API
  }
}

/** @type {import('vuex').GetterTree<any, any>} */
const assuranceGetters = {
  isUkkoturvaInitialized: (state) => {
    return !!state.ukkoturvaData
  },
  /**
   * get cached ukkoturva data for specific endpoint and language
   */
  getUkkoturvaData: (state) => (ukkoturvaEndpoint, language) => {
    return state.ukkoturvaData?.[ukkoturvaEndpoint]?.[language]
  }
}

/** @type {import('vuex').MutationTree<any>} */
const assuranceMutations = {
  clearAllData: (state) => {
    Object.assign(state, initAssuranceState())
  },
  setUkkoturvaData(state, payload) {
    state.ukkoturvaData = payload
  }
}

/** @type {import('vuex').ActionTree<any, any>} */
const assuranceActions = {
  /**
   * fetchUkkoturva
   *
   * Query data from all the endpoints
   * and set received data to a single object
   *
   */
  async fetchUkkoturva({ commit }) {
    const ukkoturvaData = {}

    const promises = [
      UKKOTURVA_OVERVIEW,
      UKKOTURVA_INSURANCE,
      UKKOTURVA_INSURANCE_CHILD_PAGES,
      UKKOTURVA_BENEFITS,
      UKKOTURVA_COURSES,
      UKKOTURVA_CONTRACT_LIBRARY
    ].map((endpointPath) =>
      axios
        .get(getBaseUrl() + endpointPath)
        .then(({ data }) => {
          ukkoturvaData[endpointPath] = data
        })
        .catch(() => {
          // set data to null if WP endpoint fails for some reason, missing data, endpoint doesn't exists etc.
          ukkoturvaData[endpointPath] = null
        })
    )

    await Promise.all(promises)

    commit('setUkkoturvaData', ukkoturvaData)
  },
  async initUkkoturva({ getters, dispatch }) {
    if (!getters.isUkkoturvaInitialized) {
      await dispatch('fetchUkkoturva')
    }
  }
}

export const assuranceModule = {
  namespaced: true,
  state: initAssuranceState,
  getters: assuranceGetters,
  actions: assuranceActions,
  mutations: assuranceMutations
}

export default assuranceModule
